module.exports = __webpack_public_path__ + "static/media/dropdown.7f110cc7.svg";